import { FADE_IN_DOCUMENT_CLASS } from './Modal.constants';
import { isDocumentDefined } from '../../../../utils/dom';
export function removeFadeInToDocument() {
  if (isDocumentDefined()) {
    document.body.classList.remove(FADE_IN_DOCUMENT_CLASS);
  }
}
export function addFadeInToDocument() {
  if (isDocumentDefined()) {
    document.body.classList.add(FADE_IN_DOCUMENT_CLASS);
  }
}